(ns teamoesterreich.user-mode.prevent.questionnaire-helper
  (:require [clojure.string]
            [goog.date.DateTime]
            ))


(defn _rank-list [questionnaire]
  (let [questions (:questions questionnaire)]
    (mapv (fn [[k e]] k) (sort-by (fn [[k e]] (:index e)) questions))
    ))

(defn get-first-uuid [questionnaire]
  (first (_rank-list questionnaire)))


(defn get-forward-uuid [questionnaire uuid]
  (let [r-list (_rank-list questionnaire)
        i (.indexOf r-list uuid)
        j (+ i 1)]
    (when (and (not= i -1) (> (count r-list) j)) (nth r-list j))))

(defn get-backward-uuid [questionnaire uuid]
  (let [r-list (_rank-list questionnaire)]
    ;(log/out "##################### get-backward-uuid= " (count r-list))
    (when (> (count r-list) 0)
      (let [i (.indexOf r-list uuid)
            j (- i 1)]
        (when (and (not= j -1) (> (count r-list) j)) (nth r-list j))))))
